var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VbDemo',[_c('VbCard',[_c('chat',{model:{value:(_vm.chatMessages),callback:function ($$v) {_vm.chatMessages=$$v},expression:"chatMessages"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }